import { TRANSLATED_ACTIONS } from '@/common/messages';
import { defineMessages } from '@/components/formatted_message/FormattedMessage';

export const Page = defineMessages({
  helmet: {
    id: 'app.auth.verify.Page.helmet',
  },
});

export const RecoveryMethod = defineMessages({
  description: {
    id: 'app.auth.lostDevice.Page.description',
  },
  alertMessage: {
    id: 'app.auth.lostDevice.Page.alertMessage',
  },
  haveRecoveryCode: {
    id: 'app.auth.lostDevice.Page.haveRecoveryCode',
  },
  doNotHaveRecoveryCode: {
    id: 'app.auth.lostDevice.Page.doNotHaveRecoveryCode',
  },
});

export const RecoveryCode = defineMessages({
  alertMessage: {
    id: 'app.auth.recoveryCode.Page.alertMessage',
  },
  verifyCode: {
    id: 'app.auth.recoveryCode.Page.verifyCode',
  },
  recoveryCode: {
    id: 'app.auth.recoveryCode.Page.recoveryCode',
  },
  errorMessage: {
    id: 'app.auth.recoveryCode.Page.errorMessage',
  },
  cancel: TRANSLATED_ACTIONS.cancel,
});

export const MissingCode = defineMessages({
  alertMessage: {
    id: 'app.auth.recoverySupport.Page.alertMessage',
  },
  errorMessage: {
    id: 'app.auth.recoverySupport.Page.errorMessage',
  },
  label: {
    id: 'app.auth.recoverySupport.Page.label',
  },
  placeholder: {
    id: 'app.auth.recoverySupport.Page.placeholder',
  },
  submit: {
    id: 'app.auth.recoverySupport.Page.submit',
  },
  alertInfoMessage: {
    id: 'app.auth.recoverySupport.Page.alertInfoMessage',
  },
  cancel: TRANSLATED_ACTIONS.cancel,
  close: TRANSLATED_ACTIONS.close,
});
